import axios from 'axios';
import { HiOutlinePhotograph } from 'react-icons/hi';
import { useState } from 'react';

const CodeqrRaffle = ({ url, name}: any) => {
  const [isLoadingImg, setIsLoadingImg] = useState<boolean>(false)
  const Download =()=>{
    setIsLoadingImg(true)
    axios({
      url,
      method:'GET',
      responseType: 'blob'
    })
    .then((response)=>{
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url;
        link.setAttribute('download',`${name}.png`)
        document.body.appendChild(link)
        link.click()
        setIsLoadingImg(false)
    })
    .catch(()=>{
        setIsLoadingImg(false)
    })
  }

  return (
    <div className="c-code-qr__container">
      <div className="c-code-qr__header">
        <span className="c-code-qr__title">{name}</span>
      </div>
      <div className="c-code-qr__content" >
        <img src={url} className={`c-code-qr__img-qr`} alt="qr-campaign"/>
      </div>
      <button className={`c-code-qr__button-download ${isLoadingImg && `c-code-qr__button-download--disabled`}`} onClick={Download}>
        {
          isLoadingImg ?
          <>
            Download...<div className="spiner"></div>
          </>
          :
          <>
              Download QR Code <HiOutlinePhotograph />
          </>
        }
      </button>
    </div>
  )
}

export default CodeqrRaffle